import React, { useEffect } from 'react';
import { mapskey } from '../../config/config';
//import axios from 'axios';

import { aws_base_path } from '../../config/config';
import { FOOD_TYPE_LABELS } from '../../constants';
import { calculateDistance } from '../../utils/locationUtils';
import { Utils } from '../../utils/utils';

const MyMap = (props) => {
  const createMarkerElement = () => {
    const markerElement = document.createElement('div');
    markerElement.style.width = '18px';
    markerElement.style.height = '18px';
    markerElement.style.borderRadius = '50%';
    markerElement.style.backgroundColor = '#d32f2f';
    markerElement.style.border = '2px solid #ffffff';
    markerElement.style.boxShadow = '0 1px 4px rgba(0, 0, 0, 0.35)';
    return markerElement;
  };

  const getFoodTypesText = (location) => {
    const foodTypes = Array.from(new Set((location.menus || [])
      .map((menu) => menu.type)
      .filter(Boolean)));

    return foodTypes.map((type) => FOOD_TYPE_LABELS[type] || type).join(' | ');
  };

  const getMockKitchenDetails = (location) => {
    const profilePicUrl = location.profilePic ? aws_base_path + location.profilePic : '';
    const kitchenUrl = location.id ? `/kitchen/${location.id}` : null;
    const foodTypesText = getFoodTypesText(location);
    const deliveryMethodText = Utils.getDeliveryMethodText(location, { concise: true });

    return `
      <div style="font-family: Arial, sans-serif; font-size: 12px; line-height: 1.4; min-width: 180px; max-width: 190px; padding-right: 0px;">
        ${profilePicUrl ? `<img src="${profilePicUrl}" alt="${location.name || 'Kitchen'}" style="width: 100%; height: 88px; object-fit: cover; border-radius: 8px; border: 1px solid #e0e0e0; margin-bottom: 8px; display: block;" />` : ''}
        <div>
          <div style="font-weight: 600; font-size: 13px; margin-bottom: 4px;">${location.name || 'Kitchen Name'}</div>
          <div>${foodTypesText}</div>
          <div>${deliveryMethodText}</div>
          ${kitchenUrl ? `<a href="${kitchenUrl}" style="display: inline-block; margin-top: 8px; color: #1976d2; font-weight: 600; text-decoration: none;">Go To Menu</a>` : ''}
        </div>
      </div>
    `;
  };

  useEffect(() => {
    const loadGoogleMapsScript = () => {
      return new Promise((resolve, reject) => {
        if (window.google && window.google.maps) {
          resolve(window.google.maps);
          return;
        }

        const script = document.createElement('script');
        script.src = `https://maps.googleapis.com/maps/api/js?key=` + mapskey + `&libraries=marker`;
        script.async = true;
        script.defer = true;

        script.onload = () => {
          resolve(window.google.maps);
        };

        script.onerror = (e) => {
          reject(e);
        };

        document.head.appendChild(script);
      });
    };

    const initMap = async () => {
      try {
        const maps = await loadGoogleMapsScript();
        const { Map } = await maps.importLibrary("maps");
        const { AdvancedMarkerElement } = await maps.importLibrary("marker");
        let activePinnedInfoWindow = null;
        let activePinnedMarkerState = null;

        const map = new Map(document.getElementById("map"), {
          center: { lat: props.coords.latitude, lng: props.coords.longitude },
          zoom: 14,
          mapId: "4504f8b37365c3d0",
        });

        let hasCompletedInitialIdle = false;

        maps.event.addListener(map, 'idle', () => {
          if (!props.onMapRadiusChange) {
            return;
          }

          if (!hasCompletedInitialIdle) {
            hasCompletedInitialIdle = true;
            return;
          }

          const bounds = map.getBounds ? map.getBounds() : null;
          const center = map.getCenter ? map.getCenter() : null;

          if (!bounds || !center || !bounds.getNorthEast) {
            return;
          }

          const northEast = bounds.getNorthEast();

          const centerLat = typeof center.lat === 'function' ? center.lat() : center.lat;
          const centerLng = typeof center.lng === 'function' ? center.lng() : center.lng;
          const northEastLat = typeof northEast.lat === 'function' ? northEast.lat() : northEast.lat;
          const northEastLng = typeof northEast.lng === 'function' ? northEast.lng() : northEast.lng;

          if (
            typeof centerLat !== 'number' ||
            typeof centerLng !== 'number' ||
            typeof northEastLat !== 'number' ||
            typeof northEastLng !== 'number'
          ) {
            return;
          }

          const visibleRadiusMiles = calculateDistance(centerLat, centerLng, northEastLat, northEastLng);
          const normalizedRadius = Math.max(1, Math.ceil(visibleRadiusMiles));

          props.onMapRadiusChange(normalizedRadius);
        });

        // Clear any existing markers (optional step)
        if (map.markers) {
          map.markers.forEach((marker) => marker.setMap(null));
        }
        map.markers = [];

        const bounds = new maps.LatLngBounds();
        bounds.extend({ lat: props.coords.latitude, lng: props.coords.longitude });

        props.locations.forEach(location => {
          bounds.extend({ lat: location.latitude, lng: location.longitude });
          const markerState = { isPinned: false };

          const infoWindow = new maps.InfoWindow({
            content: getMockKitchenDetails(location),
            disableAutoPan: true,
          });

          const markerElement = createMarkerElement();

          const marker = new AdvancedMarkerElement({
            map,
            position: { lat: location.latitude, lng: location.longitude },
            title: location.name,
            content: markerElement,
          });

          markerElement.addEventListener('mouseenter', () => {
            if (activePinnedInfoWindow && !markerState.isPinned) {
              return;
            }

            infoWindow.open({
              anchor: marker,
              map,
            });
          });

          markerElement.addEventListener('mouseleave', () => {
            if (!markerState.isPinned) {
              infoWindow.close();
            }
          });

          markerElement.addEventListener('click', () => {
            if (activePinnedInfoWindow && activePinnedMarkerState !== markerState) {
              activePinnedMarkerState.isPinned = false;
              activePinnedInfoWindow.close();
            }

            markerState.isPinned = true;
            activePinnedInfoWindow = infoWindow;
            activePinnedMarkerState = markerState;

            infoWindow.open({
              anchor: marker,
              map,
            });
          });

          infoWindow.addListener('closeclick', () => {
            markerState.isPinned = false;

            if (activePinnedMarkerState === markerState) {
              activePinnedInfoWindow = null;
              activePinnedMarkerState = null;
            }
          });

          // Store marker in an array to keep track
          map.markers.push(marker);
        });

        if (props.locations.length > 0) {
          map.fitBounds(bounds, 60);

          maps.event.addListenerOnce(map, 'bounds_changed', () => {
            if (map.getZoom() > 14) {
              map.setZoom(14);
            }
          });
        }

      } catch (error) {
        console.error("Error initializing map:", error);
      }
    };

    initMap();

    return () => {
      // Optionally, clean up any resources when the component unmounts
      const script = document.querySelector('script[src*="maps.googleapis.com"]');
      if (script) {
        document.head.removeChild(script);
      }
    };
  }, [props.coords.latitude, props.coords.longitude, props.locations, props.onMapRadiusChange]);

  return (
    <div data-testid="map-id" id="map" style={{ height: '50vh', width: '100%' }}></div>
  );
};

export default MyMap;
